import { LoanFormat } from '../../../models/LoanFormat';
import i18next from '../../../i18n';

export const formatLoanFormat = (
    loanFormat: LoanFormat | undefined,
    grammar: 'singular' | 'plural',
    alt: boolean = false
) => {
    switch (grammar) {
        case 'singular':
            return !alt ? formatLoanFormatSingular(loanFormat) : formatLoanFormatAltSingular(loanFormat);
        case 'plural':
            return !alt ? formatLoanFormatPlural(loanFormat) : formatLoanFormatAltPlural(loanFormat);
        default:
            return '';
    }
};

export const formatLoanFormatSingular = (loanFormat: LoanFormat | undefined) => {
    switch (loanFormat) {
        case LoanFormat.eBooks:
            return i18next.t('loanFormat.plainEbook');
        case LoanFormat.eAudiobooks:
            return i18next.t('loanFormat.plainEaudiobook');
        case LoanFormat.eMagazines:
        case LoanFormat.ePress:
            return i18next.t('loanFormat.plainEpress');
        default:
            return '';
    }
};

export const formatLoanFormatPlural = (loanFormat: LoanFormat | undefined) => {
    switch (loanFormat) {
        case LoanFormat.eBooks:
            return i18next.t('loanFormat.plainEbooks');
        case LoanFormat.eAudiobooks:
            return i18next.t('loanFormat.plainEaudiobooks');
        case LoanFormat.eMagazines:
        case LoanFormat.ePress:
            return i18next.t('loanFormat.plainEpress');
        default:
            return '';
    }
};

export const formatLoanFormatAltSingular = (loanFormat: LoanFormat | undefined) => {
    switch (loanFormat) {
        case LoanFormat.eBooks:
            return i18next.t('loanFormat.ebookTitle');
        case LoanFormat.eAudiobooks:
            return i18next.t('loanFormat.eaudiobookTitle');
        case LoanFormat.eMagazines:
        case LoanFormat.ePress:
            return i18next.t('loanFormat.epressTitle');
        default:
            return '';
    }
};

export const formatLoanFormatAltPlural = (loanFormat: LoanFormat | undefined) => {
    switch (loanFormat) {
        case LoanFormat.eBooks:
            return i18next.t('loanFormat.ebookTitles');
        case LoanFormat.eAudiobooks:
            return i18next.t('loanFormat.eaudiobookTitles');
        case LoanFormat.eMagazines:
        case LoanFormat.ePress:
            return i18next.t('loanFormat.epressTitles');
        default:
            return '';
    }
};
